import React from 'react';
import { forTemplate } from 'app/common/lib/util/i18n';
import cx from 'classnames';
import styles from './SuggestedSearches.less';

const format = forTemplate('card_cover_chooser');

const suggestions = [
  'productivity',
  'perspective',
  'organization',
  'colorful',
  'nature',
  'business',
  'minimal',
  'space',
  'animals',
];

interface SuggestedSearchesProps {
  onSelect: (searchText: string) => void;
}

export const SuggestedSearches: React.FunctionComponent<
  SuggestedSearchesProps
> = ({ onSelect }) => {
  return (
    <div>
      <h4 className={styles.heading}>{format('suggested-searches')}</h4>
      {suggestions.map((suggestion) => (
        <button
          className={cx('button', styles.suggestedSearchButton)}
          key={suggestion}
          onClick={(e) => {
            e.stopPropagation();
            onSelect(format(suggestion));
          }}
        >
          {format(suggestion)}
        </button>
      ))}
    </div>
  );
};
